import React, { useContext, useState } from "react";
import { get, isEmpty, find } from "lodash";
import { Button, Form, Modal } from "react-bootstrap";
import {
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  ManagePlanLayout,
  SearchableList,
  FieldDropSide,
  FieldInput,
  LoaderWrapper,
  DeleteWarning,
} from "../../../components";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  required,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  clearFieldValues,
  getSaveMessage,
  transformToMultiselectSave,
  DISTRIBUTION_WITHDRAWAL_TYPE,
  getNumber,
  synchronizeCollectionPlanGroups,
} from "../../../utils";
import {
  clearLocalCacheByModel,
  createPlanStore,
  savePlanDetailsAction,
  setManagePageLevelData,
  setManagePlanFlow,
  setManagePlanToastInfo,
} from "../../../contexts";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import InServiceForm from "./InServiceForm";
import HardShipsForm from "./HardShipsForm";
import RMDForm from "./RMDForm";
import SeparationFromService from "./SeparationFromService";
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import ForceOutForm from "./ForceOutForm";
import PermissibleForm from "./PermissibleForm";
import {
  deleteWithdrawal,
  getWithdrawal,
  listWithdrawal,
  saveWithdrawal,
  listSource,
} from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QBADForm from "./QBADForm";
import {
  documentTypeForceout,
  documentTypeHardship,
  documentTypeInservice,
  documentTypePermissible,
  documentTypeRMD,
  documentTypeSFS,
} from "../../../utils/constants/distributionDocs";

const approvalHierarchy = [
  {
    order: 1,
    userRole: 1,
    approval: true,
  },
  {
    order: 2,
    userRole: 2,
    approval: true,
  },
];
const documentType = [];

const AddDistributionsContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const { planId, flow, distributionIndex } = useRouterParams();
  // const distributionsData = get(state, "api.data.withdrawals", []);
  const { response: distributions } = useRequest({
    //to be removed
    method: listWithdrawal,
    payload: planId,
    defaultResponse: [],
  });

  const distributionsData = get(distributions, "withdrawals", []);

  const intDistributionIndex = parseInt(distributionIndex, 10);
  const [newFlow, setNewFlow] = useState(
    !isNaN(distributionIndex) ? FLOW_TYPES.EDIT : ""
  );
  const [allSources, setAllSources] = useState([]);
  const formName = managePlanFormNames.ADD_DISTRIBUTIONS;
  const fields = formFields[formName];

  const { response: distribution, loading: isLoading } = useRequest({
    method: getWithdrawal,
    payload: intDistributionIndex,
    defaultResponse: [],
  });

  useDeepEffect(() => {
    listSource(planId)
      .then((response) => {
        setAllSources(response.employerSourcesList);
      })
      .catch((error) => {
        //Handle Error
      });
  }, []);

  const formValues = get(distribution, "withdrawal", {});

  const withdrawalSources = get(formValues, fields.withdrawalSources, []);
  const sources = allSources.map((source) => {
    let withdrawalSource = find(withdrawalSources, { sourceId: source.id });
    return {
      ...source,
      withEarningType: get(withdrawalSource, "withEarningType", false),
      checked: isEmpty(withdrawalSource) ? false : true,
    };
  });
  const initialValuesForInService = {
    [fields.ageLimitApplicable]: true,
    [fields.restrictionTypes]: [1],
    [fields.years]: 59,
    [fields.months]: 6,
    [fields.waiveOffLimitApplicable]: false,
    [fields.earlyWithdrawalPenalty]: 10,
    [fields.processLesserAmountIfMaximumIsNotAvailable]: false,
    [fields.spouseConsentRequired]: false,
    [fields.sponsorApprovalRequired]: false,
    [fields.availableToBeneficiaries]: false,
    [fields.availableToAlternatePayees]: false,
    [fields.allowOptingOutOfFederlWithholdingTax]: false,
    [fields.allowOptingOutOfStateWithholdingTax]: false,
    [fields.allowChangingOfFederalWithholdingTax]: false,
    [fields.allowChangingOfStateWithholdingTax]: false,
    [fields.distributionAllocationPaymentMethod]: [1],
    [fields.distributionAllocationMethod]: [1],
    [fields.allowParticipantstoChooseFeesDeductedMethod]: false,
    [fields.feesToBeDeductedFrom]: 2,
    approvalHierarchy: approvalHierarchy,
    withdrawalDocumentType: documentTypeInservice,
  };

  const initialValuesForHardship = {
    // [fields.waiveOffLimitApplicable]: false,
    [fields.requiresInServiceWithdrawalPriorToHardshipRequest]: false,
    [fields.requiresLoanRequestPriorToHardshipRequest]: false,
    [fields.processLesserAmountIfMaximumIsNotAvailable]: false,
    [fields.spouseConsentRequired]: false,
    [fields.earlyWithdrawalPenalty]: 10,
    [fields.sponsorApprovalRequired]: false,
    [fields.availableToBeneficiaries]: false,
    [fields.availableToAlternatePayees]: false,
    [fields.allowOptingOutOfFederlWithholdingTax]: false,
    [fields.allowOptingOutOfStateWithholdingTax]: false,
    [fields.allowChangingOfFederalWithholdingTax]: false,
    [fields.allowChangingOfStateWithholdingTax]: false,
    [fields.lengthOfSuspensionApplicable]: false,
    [fields.restrictNumberOfHardshipsInDefinedPeriod]: false,
    [fields.distributionAllocationPaymentMethod]: [1],
    [fields.distributionAllocationMethod]: [1],
    [fields.allowParticipantstoChooseFeesDeductedMethod]: false,
    [fields.feesToBeDeductedFrom]: 2,
    approvalHierarchy: approvalHierarchy,

    withdrawalDocumentType: documentTypeHardship,
  };

  const initialValuesForRMD = {
    [fields.waiveOffLimitApplicable]: false,
    [fields.processLesserAmountIfMaximumIsNotAvailable]: false,
    [fields.spouseConsentRequired]: false,
    [fields.sponsorApprovalRequired]: false,
    [fields.allowOptingOutOfFederlWithholdingTax]: false,
    [fields.allowOptingOutOfStateWithholdingTax]: false,
    [fields.allowChangingOfFederalWithholdingTax]: false,
    [fields.allowChangingOfStateWithholdingTax]: false,
    [fields.distributionAllocationMethodAutoRMD]: 1,
    [fields.calculationMethods]: null,
    // [fields.defaultPaymentFrequnecyForAutoRMD]: null,
    [fields.distributionAllocationPaymentMethod]: [1],
    [fields.distributionAllocationMethod]: [1],
    [fields.feesToBeDeductedFrom]: 2,
    [fields.allowParticipantstoChooseFeesDeductedMethod]: false,
    approvalHierarchy: approvalHierarchy,
    withdrawalDocumentType: documentTypeRMD,
  };

  const initialValuesForSFS = {
    [fields.waiveOffLimitApplicable]: false,
    [fields.processLesserAmountIfMaximumIsNotAvailable]: false,
    [fields.spouseConsentRequired]: false,
    [fields.sponsorApprovalRequired]: false,
    [fields.availableToBeneficiaries]: false,
    [fields.recurringFeeApplicable]: false,
    [fields.availableToAlternatePayees]: false,
    [fields.allowOptingOutOfFederlWithholdingTax]: false,
    [fields.allowOptingOutOfStateWithholdingTax]: false,
    [fields.allowChangingOfFederalWithholdingTax]: false,
    [fields.allowChangingOfStateWithholdingTax]: false,
    [fields.distributionAllocationMethod]: [1],
    [fields.calculationMethods]: null,
    [fields.dateOfAnnuityPayments]: [],
    [fields.periodicPaymentMethod]: [1],
    [fields.periodicPaymentApplicable]: false,
    [fields.feesToBeDeductedFrom]: 2,
    [fields.allowParticipantstoChooseFeesDeductedMethod]: false,
    [fields.distributionAllocationPaymentMethod]: [1],
    approvalHierarchy: approvalHierarchy,
    withdrawalDocumentType: documentTypeSFS,
  };
  const initialValuesForFO = {
    [fields.availableToBeneficiaries]: false,
    [fields.availableToAlternatePayees]: false,
    [fields.sponsorApprovalRequired]: false,
    [fields.allowOptingOutOfFederlWithholdingTax]: false,
    [fields.allowOptingOutOfStateWithholdingTax]: false,
    [fields.allowChangingOfFederalWithholdingTax]: false,
    [fields.allowChangingOfStateWithholdingTax]: false,
    [fields.distributionAllocationPaymentMethod]: [1],
    [fields.distributionAllocationMethod]: [1],
    [fields.allowParticipantstoChooseFeesDeductedMethod]: false,
    approvalHierarchy: approvalHierarchy,
    withdrawalDocumentType: documentTypeForceout,
    [fields.feesToBeDeductedFrom]: 2,
  };
  const initialValuesForPermissible = {
    [fields.availableToBeneficiaries]: false,
    [fields.availableToAlternatePayees]: false,
    [fields.sponsorApprovalRequired]: false,
    [fields.allowOptingOutOfFederlWithholdingTax]: false,
    [fields.allowOptingOutOfStateWithholdingTax]: false,
    [fields.allowChangingOfFederalWithholdingTax]: false,
    [fields.allowChangingOfStateWithholdingTax]: false,
    [fields.distributionAllocationPaymentMethod]: [1],
    [fields.distributionAllocationMethod]: [1],
    [fields.allowParticipantstoChooseFeesDeductedMethod]: false,
    approvalHierarchy: approvalHierarchy,
    withdrawalDocumentType: documentTypePermissible,
    [fields.feesToBeDeductedFrom]: 2,
  };
  const initialValuesForQBAD = {
    [fields.processLesserAmountIfMaximumIsNotAvailable]: false,
    [fields.maximumWithDrawalLimitAmount]: 5000,
    [fields.allowOptingOutOfFederlWithholdingTax]: false,
    [fields.allowOptingOutOfStateWithholdingTax]: false,
    [fields.allowChangingOfFederalWithholdingTax]: false,
    [fields.allowChangingOfStateWithholdingTax]: false,
    [fields.distributionAllocationPaymentMethod]: [1],
    [fields.distributionAllocationMethod]: [1],
    [fields.allowParticipantstoChooseFeesDeductedMethod]: false,
    [fields.feesToBeDeductedFrom]: 2,
    [fields.withdrawalLimitPerPeriod]: 4,
    approvalHierarchy: approvalHierarchy,
  };
  const DeleteToastMessage = "You are attempting to delete distribution.";
  const DeleteToastMessageHead = "Delete Distribution ?";
  const [errorMsg, setErrorMsg] = useState("");
  const [showWarning, setShowWarning] = useState(false);

  const onDeleteClick = () => {
    setShowWarning(true);
  };
  const [isModalOpen, setIsModalOpen] = useState(0);

  const handleClose = () => {
    setIsModalOpen(false);
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const handleConfirmClick1 = () => {
    distributionsData.splice(intDistributionIndex, 1);
    deleteWithdrawal(distributionIndex).then((response) => {
      if (response.isSuccessful) {
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: `Data deleted successfully`,
          })
        );
        dispatch(clearLocalCacheByModel("withdrawalSources"));
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.DISTRIBUTIONS,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
      } else {
        var x = response.errorMessages;
        if (
          //x[0].controlName == null &&
          x[0].errorCode !== null &&
          x[0].message !== null
        ) {
          setErrorMsg(`${x[0].errorCode} : ${x[0].message}`);
          setIsModalOpen(true);
        }
      }
    });
  };

  // const onDeleteClick = () => {
  //   distributionsData.splice(intDistributionIndex, 1);
  //   deleteWithdrawal(distributionIndex).then((response) => {
  //     if (response.isSuccessful) {
  //       //const newPlanId = get(response, "plan.id");
  //       dispatch(
  //         setManagePlanToastInfo({
  //           showToast: true,
  //           toastMessage: `Data deleted successfully`,
  //         })
  //       );
  //       dispatch(clearLocalCacheByModel("withdrawalSources"));
  //       history.push(
  //         getPathWithParam({
  //           path: MANAGE_PLAN_ROUTES.DISTRIBUTIONS,
  //           pathParam: [FLOW_TYPES.EDIT, planId],
  //         })
  //       );
  //     }
  //   });
  // };

  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.DISTRIBUTIONS,
        pathParam: [FLOW_TYPES.EDIT, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      onClick: () => dispatch(clearLocalCacheByModel("withdrawalSources")),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.DISTRIBUTIONS,
        pathParam: [FLOW_TYPES.EDIT, planId],
      }),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => setNewFlow(FLOW_TYPES.SAVE),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: onDeleteClick,
    },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: onDeleteClick,
    // },
  ];

  const getDataForSave = (values) => {
    // distributionDocument
    const updatedValues = {
      ...formValues,
      ...values,
      planId: planId,
      [fields.withDrawalType]: values[fields.withDrawalType]
        ? values[fields.withDrawalType]
        : null,
      [fields.checkFees]: getNumber(values[fields.checkFees]),
      [fields.eftFee]: getNumber(values[fields.eftFee]),
      [fields.recurringFee]: getNumber(values[fields.recurringFee]),
      [fields.overnightExpressDeliveryFee]: getNumber(
        values[fields.overnightExpressDeliveryFee]
      ),
      [fields.withdrawalOneTimeOriginateFee]: getNumber(
        values[fields.withdrawalOneTimeOriginateFee]
      ),
      [fields.rollOverFee]: getNumber(values[fields.rollOverFee]),
      [fields.minimumWithDrawalLimitAmount]: getNumber(
        values[fields.minimumWithDrawalLimitAmount]
      ),
      [fields.maximumWithDrawalLimitAmount]: getNumber(
        values[fields.maximumWithDrawalLimitAmount]
      ),
      [fields.suspensionPeriodMonths]: getNumber(
        values[fields.suspensionPeriodMonths]
      ),
      [fields.suspensionPeriodYears]: getNumber(
        values[fields.suspensionPeriodYears]
      ),
      [fields.restrictedPeriodValue]: getNumber(
        values[fields.restrictedPeriodValue]
      ),
      [fields.maximumNoOfHardShips]: getNumber(
        values[fields.maximumNoOfHardShips]
      ),
      [fields.earlyWithdrawalPenalty]: getNumber(
        values[fields.earlyWithdrawalPenalty]
      ),
      [fields.excludedEmployeeClassifications]: [
        ...transformToMultiselectSave(
          (values[fields.excludedEmployeeClassifications] || []).filter(
            (val) =>
              !get(formValues, fields.excludedEmployeeClassifications, [])
                .map((_) => _.employeeClassificationId)
                .includes(val)
          ),
          "employeeClassificationId"
        ),
        ...get(
          formValues,
          fields.excludedEmployeeClassifications,
          []
        )?.filter((val) =>
          (values[fields.excludedEmployeeClassifications] || []).includes(
            val.employeeClassificationId
          )
        ),
      ],
      [fields.excludedEmploymentStatuses]: [
        ...transformToMultiselectSave(
          (values[fields.excludedEmploymentStatuses] || []).filter(
            (val) =>
              !get(formValues, fields.excludedEmploymentStatuses, [])
                .map((_) => _.employmentStatusId)
                .includes(val)
          ),
          "employmentStatusId"
        ),
        ...get(
          formValues,
          fields.excludedEmploymentStatuses,
          []
        ).filter((val) =>
          (values[fields.excludedEmploymentStatuses] || []).includes(
            val.employmentStatusId
          )
        ),
      ],

      [fields.withdrawalSources]: synchronizeCollectionPlanGroups(
        get(formValues, fields.withdrawalSources) ?? [],
        (get(values, fields.withdrawalSources) ?? []).map((source) => {
          return {
            sourceId: source.id,
            withEarningType: source.withEarningType,
            id:
              find(get(formValues, fields.withdrawalSources, []), {
                sourceId: source.id,
              })?.id || 0,
          };
        }),
        "id"
      ),
      [fields.suspendedSources]: [
        ...transformToMultiselectSave(
          (values[fields.suspendedSources] || [])?.filter(
            (val) =>
              !get(formValues, fields.suspendedSources, [])
                .map((_) => _.sourceId)
                .includes(val)
          ),
          "sourceId"
        ),
        ...(get(formValues, fields.suspendedSources, []) || [])?.filter((val) =>
          (values[fields.suspendedSources] || []).includes(val.sourceId)
        ),
      ],

      //Conditional Field Clears
      [fields.waiveOffLimit]: values[fields.waiveOffLimitApplicable]
        ? getNumber(values[fields.waiveOffLimit])
        : null,
      [fields.maximumNumberOfDirectRolloverPayees]: getNumber(
        values[fields.maximumNumberOfDirectRolloverPayees]
      ),

      [fields.feesToBeDeductedFrom]: values[
        fields.allowParticipantstoChooseFeesDeductedMethod
      ]
        ? null
        : values[fields.feesToBeDeductedFrom] || null,
      [fields.numberOfWithdrawalAllowed]:
        values[fields.withdrawalLimitPerPeriod] &&
        values[fields.withdrawalLimitPerPeriod] !== 3
          ? values[fields.numberOfWithdrawalAllowed]
          : null,
      [fields.numberOfWithdrawalAllowed]: getNumber(
        values[fields.numberOfWithdrawalAllowed]
      ),
      [fields.years]: values[fields.ageLimitApplicable]
        ? values[fields.years]
        : null,
      [fields.months]: values[fields.ageLimitApplicable]
        ? values[fields.months]
        : null,
      [fields.waiveOffLimitReason]: values[fields.waiveOffLimitReason]
        ? values[fields.waiveOffLimitReason]
        : null,
      approvalHierarchy: values["approvalHierarchy"]
        ? values["approvalHierarchy"].map((item) => {
            return {
              order: item.order,
              userRole: item.userRole,
              approval: item.approval,
              id: item.id ? item.id : 0,
            };
          })
        : [],
    };
    return updatedValues;
    // if (isEmpty(formValues)) {
    //   return [...distributionsData, updatedValues];
    // }
    // return distributionsData.map((distribution, index) => {
    //   if (index === intDistributionIndex) {
    //     return {
    //       ...distribution,
    //       ...updatedValues,
    //     };
    //   }
    //   return distribution;
    // });
  };

  const [apiLoading, setApiLoading] = useState(false);
  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    // console.log("valuesssss", values);

    setApiLoading(true);
    const { history } = props;
    saveWithdrawal(getDataForSave(values)).then((response) => {
      setApiLoading(false);
      if (response.isSuccessful) {
        //const newPlanId = get(response,"plan.id");
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.DISTRIBUTIONS,
            pathParam: [flow, planId], // put the company id after crated
          })
        );
        dispatch(
          setManagePlanFlow({
            planId: planId,
          })
        );
        dispatch(
          setManagePageLevelData({
            formName: formName,
            fieldData: values,
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: getSaveMessage(
              distributionIndex,
              `Distribution ${
                OPTIONS_DATA_MAPPER.DISTRIBUTIONS_TYPE[
                  values[fields.withDrawalType]
                ]
              } created successfully`
            ),
          })
        );
        dispatch(clearLocalCacheByModel("withdrawalSources"));
      } else {
        setSubmitting(false);
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };
  const isEdit = newFlow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  return (
    <Formik
      initialValues={{
        ...formValues,
        [fields.excludedEmploymentStatuses]: get(
          formValues,
          fields.excludedEmploymentStatuses,
          []
        )?.map((val) => val.employmentStatusId),
        [fields.excludedEmployeeClassifications]: get(
          formValues,
          fields.excludedEmployeeClassifications,
          []
        )?.map((val) => val.employeeClassificationId),
        [fields.withdrawalSources]: (sources || []).filter(
          (source) => source.checked
        ),
        [fields.suspendedSources]: get(
          formValues,
          fields.suspendedSources,
          []
        )?.map((val) => val.sourceId),

        [fields.withdrawalDocumentType]: !isEmpty(
          get(formValues, fields.withdrawalDocumentType, [])
        )
          ? get(formValues, fields.withdrawalDocumentType).map((_) => {
              return { ..._, isViewOnly: true };
            })
          : documentType,

        // [fields.loanDocumentType]: documentType,
        // [fields.withdrawalDocumentType]: documentType,

        // "loanDocumentType": documentType,
        // ['loanDocumentType']: get(formValues, 'loanDocumentType', []):documentType,
        // [fields.approvalHierarchy]: get(
        //   formValues,
        //   fields.approvalHierarchy,
        //   []
        // )?.sort((a, b) => a.order - b.order),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          setSubmitting,
          values,
          ...rest
        } = formProps;
        const onDistributionTypeChange = (value) => {
          rest.setErrors({});
          const updatedValues = clearFieldValues({
            values,
            fieldsToExculde: [fields.withDrawalType],
          });
          switch (value) {
            case DISTRIBUTION_WITHDRAWAL_TYPE.In_Service:
              setValues({
                ...updatedValues,
                [fields.withDrawalType]: value,
                ...initialValuesForInService,
              });
              break;
            case DISTRIBUTION_WITHDRAWAL_TYPE.Hardship:
              setValues({
                ...updatedValues,
                [fields.withDrawalType]: value,
                ...initialValuesForHardship,
              });
              break;
            case DISTRIBUTION_WITHDRAWAL_TYPE.Required_Minimum_Distribution:
              setValues({
                ...updatedValues,
                [fields.withDrawalType]: value,
                ...initialValuesForRMD,
              });
              break;
            case DISTRIBUTION_WITHDRAWAL_TYPE.Force_Out:
              setValues({
                ...updatedValues,
                [fields.withDrawalType]: value,
                ...initialValuesForFO,
              });
              break;
            case DISTRIBUTION_WITHDRAWAL_TYPE.Separation_from_Service:
              setValues({
                ...updatedValues,
                [fields.withDrawalType]: value,
                ...initialValuesForSFS,
              });

              break;
            case DISTRIBUTION_WITHDRAWAL_TYPE.Permissible_Withdrawal:
              setValues({
                ...updatedValues,
                [fields.withDrawalType]: value,
                ...initialValuesForPermissible,
              });
              break;
            case DISTRIBUTION_WITHDRAWAL_TYPE.QBAD:
              setValues({
                ...updatedValues,
                [fields.withDrawalType]: value,
                ...initialValuesForQBAD,
              });
              break;
            default:
              break;
          }
          setTouched({});
        };
        const onHardshipReasonChange = (value) => {
          const updatedValues = clearFieldValues({
            values,
            fieldsToClear: [fields.otherHardshipReason],
          });
          setValues({
            ...updatedValues,
            [fields.hardshipReason]: value,
          });
          setTouched({ [fields.otherHardshipReason]: false });
        };

        const isHardShips = [DISTRIBUTION_WITHDRAWAL_TYPE.Hardship].includes(
          values[fields.withDrawalType]
        );
        const isInService = [DISTRIBUTION_WITHDRAWAL_TYPE.In_Service].includes(
          values[fields.withDrawalType]
        );
        const isPermissible = [
          DISTRIBUTION_WITHDRAWAL_TYPE.Permissible_Withdrawal,
        ].includes(values[fields.withDrawalType]);
        const isSfs = [
          DISTRIBUTION_WITHDRAWAL_TYPE.Separation_from_Service,
        ].includes(values[fields.withDrawalType]);
        const isRmd = [
          DISTRIBUTION_WITHDRAWAL_TYPE.Required_Minimum_Distribution,
        ].includes(values[fields.withDrawalType]);
        const isForceOut = [DISTRIBUTION_WITHDRAWAL_TYPE.Force_Out].includes(
          values[fields.withDrawalType]
        );
        const isQBAD = [DISTRIBUTION_WITHDRAWAL_TYPE.QBAD].includes(
          values[fields.withDrawalType]
        );

        return (
          <LoaderWrapper isLoading={isLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout
                buttons={buttons}
                pageFlow={newFlow || flow}
                layoutHeader={distributionIndex && "Distribution"}
              >
                <Field
                  size="md"
                  isRequired
                  label="Distribution Type"
                  name={fields.withDrawalType}
                  value={values[fields.withDrawalType]}
                  disabled={isEdit || isSave}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.DISTRIBUTIONS_TYPE
                  )}
                  popupContent={
                    <SearchableList
                      label="Select a Type"
                      isNotTypeAhead
                      isRadio
                      selectedValue={values[fields.withDrawalType]}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.DISTRIBUTIONS_TYPE
                      )}
                      onSelect={onDistributionTypeChange}
                    />
                  }
                  component={FieldDropSide}
                />
                {!isHardShips && (
                  <Field
                    size="md"
                    isRequired
                    name={fields.withdrawalDescription}
                    label={"Withdrawal Description"}
                    type="text"
                    autoComplete="off"
                    value={values[fields.withdrawalDescription]}
                    onChange={handleChange}
                    disabled={isEdit && !isSave}
                    component={FieldInput}
                  />
                )}
                {isHardShips && (
                  <Field
                    size="md"
                    isRequired
                    label="Hardship Reason"
                    name={fields.hardshipReason}
                    value={values[fields.hardshipReason]}
                    disabled={isEdit && !isSave}
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.DISTRIBUTIONS_HARDSHIP_REASONS
                    )}
                    popupContent={
                      <SearchableList
                        label="Select Hardship Reason"
                        isNotTypeAhead
                        isRadio
                        selectedValue={values[fields.hardshipReason]}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.DISTRIBUTIONS_HARDSHIP_REASONS
                        )}
                        onSelect={onHardshipReasonChange}
                      />
                    }
                    component={FieldDropSide}
                  />
                )}
                {isHardShips && values[fields.hardshipReason] === 8 && (
                  <Field
                    isRequired
                    name={fields.otherHardshipReason}
                    label={"Other Hardship Reason"}
                    type="text"
                    autoComplete="off"
                    value={values[fields.otherHardshipReason]}
                    onChange={handleChange}
                    disabled={isEdit && !isSave}
                    component={FieldInput}
                  />
                )}
                <br />
                {isHardShips && (
                  <HardShipsForm
                    {...formProps}
                    fields={fields}
                    isEdit={isEdit}
                    isSave={isSave}
                    isHardShips={isHardShips}
                    sources={sources}
                    planId={planId}
                  />
                )}
                {isInService && (
                  <InServiceForm
                    {...formProps}
                    fields={fields}
                    isEdit={isEdit}
                    isSave={isSave}
                    isInService={isInService}
                    sources={sources}
                    planId={planId}
                  />
                )}
                {isSfs && (
                  <SeparationFromService
                    {...formProps}
                    fields={fields}
                    isEdit={isEdit}
                    isSave={isSave}
                    isSfs={isSfs}
                    sources={sources}
                    planId={planId}
                  />
                )}
                {isRmd && (
                  <RMDForm
                    {...formProps}
                    fields={fields}
                    isEdit={isEdit}
                    isSave={isSave}
                    isRmd={isRmd}
                    planId={planId}
                  />
                )}
                {isForceOut && (
                  <ForceOutForm
                    {...formProps}
                    fields={fields}
                    isEdit={isEdit}
                    isSave={isSave}
                    isForceOut={isForceOut}
                    sources={sources}
                    planId={planId}
                  />
                )}
                {isPermissible && (
                  <PermissibleForm
                    {...formProps}
                    fields={fields}
                    isEdit={isEdit}
                    isSave={isSave}
                    isPermissible={isPermissible}
                    sources={sources}
                    planId={planId}
                  />
                )}
                {isQBAD && (
                  <QBADForm
                    {...formProps}
                    fields={fields}
                    isEdit={isEdit}
                    isSave={isSave}
                    isQBAD={isQBAD}
                    sources={sources}
                    planId={planId}
                  />
                )}
                <DeleteWarning
                  DeleteToastMessageHead={DeleteToastMessageHead}
                  DeleteToastMessage={DeleteToastMessage}
                  showModal={showWarning}
                  handleConfirmClick={handleConfirmClick1}
                  handleCancelClick={handleCancelClick}
                />
                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <p>{errorMsg}</p>
                        <br />
                        <Button className="cancel-btn" onClick={handleClose}>
                          Ok
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default AddDistributionsContainer;
